/* Module for md farm */

import mdApi from '../../api/mdApi'
import * as types from '../mutation-types'

const state = {
    authenticated: false
}

const getters = {

}

const mutations = {
    [types.SET_MD_AUTH_STATUS] : (state, data) => {
        state.authenticated = data || false;
    },
}

const actions = {
    doAuthentication({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            mdApi.authenticate()
                .then((res) => {
                    commit(types.SET_MD_AUTH_STATUS, res?.authenticated);
                    resolve(res);
                }).catch((e) => {
                    reject(e);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
